import { useAuthContext } from '@context/Auth';
import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { REGISTRATION_COMPLETION } from '@pages/Payment/PaymentRegistration/focuskey';
import constate from 'constate';
import { useNavigate } from 'react-router-dom';
import { usePaymentMethodsContext } from '../PaymentMethods';

const usePaymentRegistration = () => {
  const navigate = useNavigate();

  const { setFocus } = useFocusable();

  const setButtonFocus = () => {
    setFocus(REGISTRATION_COMPLETION);
  };

  const { deviceToken } = useAuthContext();
  const {paymentMethods, refetchPaymentMethods} = usePaymentMethodsContext();

  // TODO: 엔드포인트 env화
  const targetUrl = `${process.env.REACT_APP_GOODOC_MOBILE_WEB_URL}/payment/registration/?token=${deviceToken}`;

  const checkRegistered = async () => {
    const { data: paymentMethodsResponse } = await refetchPaymentMethods();
    if (paymentMethodsResponse?.paymentMethods.length) {
      navigate(-1);
      return;
    }
  };

  return {
    setButtonFocus,
    targetUrl,
    checkRegistered,
    paymentMethods
  };
};

export const [PaymentRegistrationProvider, usePaymentRegistrationContext] =
  constate(usePaymentRegistration);
